import React from 'react';
import NodeSymbolSelect from './NodeSymbolSelect';
import { Handle, Position } from 'reactflow';

const boxStyle = {
  padding: 12, borderRadius: 8, border: '2px solid #7c3aed',
  background: 'var(--card)', minWidth: 220, fontSize: 13, color: 'var(--text)',
};
const selStyle = {
  width: '100%', marginBottom: 6, padding: 4, background: 'var(--surface)',
  color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4,
};

export default function OrderBlockNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };
  const output = data.output || 'in_zone';
  return (
    <div style={boxStyle}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#a78bfa' }}>🧱 Order Block</div>
      <NodeSymbolSelect value={data.symbol} onChange={(v) => onChange('symbol', v)} />

      <select value={data.direction || 'bullish'} onChange={(e) => onChange('direction', e.target.value)} style={selStyle}>
        <option value="bullish">Bullish (demand zone below)</option>
        <option value="bearish">Bearish (supply zone above)</option>
      </select>

      <select value={output} onChange={(e) => onChange('output', e.target.value)} style={selStyle}>
        <option value="in_zone">Price In Zone (1/0)</option>
        <option value="top">Zone Top (price)</option>
        <option value="bottom">Zone Bottom (price)</option>
      </select>

      <div style={{ marginTop: 2, fontSize: 10, color: 'var(--muted)' }}>
        {output === 'in_zone'
          ? 'Fires (1) when price returns into the last order block. Compare with value 1.'
          : 'Outputs the order block price edge — compare against price.'}
      </div>

      <Handle type="source" position={Position.Right} id="output" style={{ background: '#7c3aed' }} />
    </div>
  );
}
